module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":"Command","placeholder":"Type a command","no_results":"No command results","menu":{"change_language":"Naar Nederlands 🇳🇱","contact":"Contact us","theme":"Change theme"}},"nl":{"label":"Actie","placeholder":"Zoek een opdracht","no_results":"Geen resultaten","menu":{"change_language":"Switch to english 🇬🇧","contact":"Contact opnemen","theme":"Thema aanpassen"}}}')
  delete Component.options._Ctor
}
